var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState } from "react";
import styled from "styled-components";
var ResultItem = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    // margin-bottom: 14px;\n    cursor: pointer;\n    transition: 0.15s;\n    padding-left: 16px;\n    padding-right: 16px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    &:hover {\n        //opacity: 0.7;\n        background: #262C30;\n    }\n"], ["\n    // margin-bottom: 14px;\n    cursor: pointer;\n    transition: 0.15s;\n    padding-left: 16px;\n    padding-right: 16px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    &:hover {\n        //opacity: 0.7;\n        background: #262C30;\n    }\n"])));
var ResultItemName = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    letter-spacing: -0.02em;\n    color: #FEFEFE;\n"], ["\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    letter-spacing: -0.02em;\n    color: #FEFEFE;\n"])));
var ResultItemType = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 13px;\n    letter-spacing: 0.06em;\n    color: #FEFEFE;\n    opacity: 0.47;\n"], ["\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 13px;\n    letter-spacing: 0.06em;\n    color: #FEFEFE;\n    opacity: 0.47;\n"])));
export default function ResItem(props) {
    var name = props.name, description = props.description, coordinates = props.coordinates, isNoResult = props.isNoResult, onClickRes = props.onClickRes;
    var _a = useState(''), searchText = _a[0], setSearchText = _a[1];
    var _b = useState(null), searchResults = _b[0], setSearchResults = _b[1];
    if (isNoResult) {
        return React.createElement(ResultItem, null,
            React.createElement(ResultItemName, null, "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432"));
    }
    return React.createElement(React.Fragment, null,
        React.createElement(ResultItem, { onClick: function () { return onClickRes(coordinates, name, description); } },
            React.createElement(ResultItemName, null, name),
            React.createElement(ResultItemType, null, coordinates)));
}
var templateObject_1, templateObject_2, templateObject_3;
/*

const ResultItem = styled.div`
    margin-bottom: 14px;
    cursor: pointer;
    transition: 0.15s;
    &:hover {
        opacity: 0.7;
    }
`

const ResultItemName = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: -0.02em;
    color: #FEFEFE;
`


const ResultItemType = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 13px;
    letter-spacing: 0.06em;
    color: #FEFEFE;
    opacity: 0.47;
`


export default function ResItem(props) {


    const { name, description, coordinates, isNoResult, onClickRes } = props;
    const [searchText, setSearchText] = useState('')
    const [searchResults, setSearchResults] = useState(null)

    if (isNoResult) {
        return <ResultItem>
                    <ResultItemName>
                        Нет результатов
                    </ResultItemName>
                </ResultItem>
    }

    return <>
            <ResultItem onClick={() => onClickRes(coordinates, name, description)}>
                <ResultItemName>
                    {name}
                </ResultItemName>
                <ResultItemType>
                    {description}
                </ResultItemType>
            </ResultItem>
        </>
}

*/ 
//# sourceMappingURL=resultitem.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState } from "react";
import styled from "styled-components";
var ResultItem = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    // margin-bottom: 14px;\n    cursor: pointer;\n    transition: 0.15s;\n    padding-left: 16px;\n    padding-right: 16px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    &:hover {\n        //opacity: 0.7;\n        background: #262C30;\n    }\n"], ["\n    // margin-bottom: 14px;\n    cursor: pointer;\n    transition: 0.15s;\n    padding-left: 16px;\n    padding-right: 16px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    &:hover {\n        //opacity: 0.7;\n        background: #262C30;\n    }\n"])));
var ResultItemName = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    letter-spacing: -0.02em;\n    color: #FEFEFE;\n"], ["\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    letter-spacing: -0.02em;\n    color: #FEFEFE;\n"])));
var ResultItemType = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 13px;\n    letter-spacing: 0.06em;\n    color: #FEFEFE;\n    opacity: 0.47;\n"], ["\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 13px;\n    letter-spacing: 0.06em;\n    color: #FEFEFE;\n    opacity: 0.47;\n"])));
export default function ResItem(props) {
    var name = props.name, description = props.description, coordinates = props.coordinates, isNoResult = props.isNoResult, onClickRes = props.onClickRes;
    var _a = useState(''), searchText = _a[0], setSearchText = _a[1];
    var _b = useState(null), searchResults = _b[0], setSearchResults = _b[1];
    if (isNoResult) {
        return React.createElement(ResultItem, null,
            React.createElement(ResultItemName, null, "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432"));
    }
    return React.createElement(React.Fragment, null,
        React.createElement(ResultItem, { onClick: function () { return onClickRes(coordinates, name, description); } },
            React.createElement(ResultItemName, null, name),
            React.createElement(ResultItemType, null, coordinates)));
}
var templateObject_1, templateObject_2, templateObject_3;
/*

const ResultItem = styled.div`
    margin-bottom: 14px;
    cursor: pointer;
    transition: 0.15s;
    &:hover {
        opacity: 0.7;
    }
`

const ResultItemName = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: -0.02em;
    color: #FEFEFE;
`


const ResultItemType = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 13px;
    letter-spacing: 0.06em;
    color: #FEFEFE;
    opacity: 0.47;
`


export default function ResItem(props) {


    const { name, description, coordinates, isNoResult, onClickRes } = props;
    const [searchText, setSearchText] = useState('')
    const [searchResults, setSearchResults] = useState(null)

    if (isNoResult) {
        return <ResultItem>
                    <ResultItemName>
                        Нет результатов
                    </ResultItemName>
                </ResultItem>
    }

    return <>
            <ResultItem onClick={() => onClickRes(coordinates, name, description)}>
                <ResultItemName>
                    {name}
                </ResultItemName>
                <ResultItemType>
                    {description}
                </ResultItemType>
            </ResultItem>
        </>
}

*/ 
//# sourceMappingURL=resultitem.js.map